import React from 'react';
import GroupTable from 'components/UiKit/GroupTable';
import PropTypes from 'prop-types';
import CropZoneCell from '../CropZoneCell';

const addedTableViewDefaultPropMassiveChangeSummary = {};
const addedTableViewDefaultPropMappedFarmView = [];
const AddedTableView = ({
  massiveChangeSummary = addedTableViewDefaultPropMassiveChangeSummary,
  mappedFarmView = addedTableViewDefaultPropMappedFarmView
}) => {
  return (
    <GroupTable>
      <GroupTable.RowGroup arrowIcon>
        <GroupTable.Row>
          <GroupTable.Cell>
            <p className="font-semibold font-body" data-testid="view-by-crops">
              {massiveChangeSummary.crop.name}
            </p>
          </GroupTable.Cell>
        </GroupTable.Row>
        {Object.entries(mappedFarmView).map(farm => (
          <GroupTable.RowGroup arrowIcon key={farm[0]}>
            <GroupTable.Row>
              <GroupTable.Cell>
                <p className="font-semibold font-body">{farm[0]}</p>
              </GroupTable.Cell>
            </GroupTable.Row>
            {farm[1].map(property => {
              return (
                <GroupTable.RowGroup arrowIcon key={property.id}>
                  <GroupTable.Row>
                    <GroupTable.Cell>
                      <p className="font-semibold font-body">{property.name}</p>
                    </GroupTable.Cell>
                  </GroupTable.Row>
                  <GroupTable.Row>
                    <GroupTable.Cell>
                      <CropZoneCell
                        massiveChangeSummary={massiveChangeSummary}
                        property={property}
                        key={property.id}
                      />
                    </GroupTable.Cell>
                  </GroupTable.Row>
                </GroupTable.RowGroup>
              );
            })}
          </GroupTable.RowGroup>
        ))}
      </GroupTable.RowGroup>
    </GroupTable>
  );
};

AddedTableView.propTypes = {
  massiveChangeSummary: PropTypes.shape(),
  mappedFarmView: PropTypes.arrayOf(PropTypes.array)
};

export default AddedTableView;
